import {
  addition,
  MAX_ZOOM_LEVEL,
  MIN_ZOOM_LEVEL,
  modifiedDocument,
  originalDocument,
  singleDocument,
} from '../Constants/commonConstants';
// import { trackButtonClick } from '../analytics/mixpanel';

// export const handleFilter = (allCardData, setCardData) => {
//   const insertedChecked = document.getElementById('INSERTED')?.checked;
//   const deletedChecked = document.getElementById('DELETED')?.checked;
//   const replacedChecked = document.getElementById('MODIFIED')?.checked;
//   if (insertedChecked && deletedChecked && replacedChecked) {
//     trackButtonClick({ type: 'Filter Data' });
//     setCardData([...allCardData]);
//   } else if (insertedChecked && deletedChecked) {
//     trackButtonClick({ type: 'Filter Data' });
//     setCardData(
//       allCardData.filter(
//         (card) => card.kind === 'inserted' || card.kind === 'deleted',
//       ),
//     );
//   } else if (deletedChecked && replacedChecked) {
//     trackButtonClick({ type: 'Filter Data' });
//     setCardData(
//       allCardData.filter(
//         (card) => card.kind === 'deleted' || card.kind === 'replaced',
//       ),
//     );
//   } else if (insertedChecked && replacedChecked) {
//     trackButtonClick({ type: 'Filter Data' });
//     setCardData(
//       allCardData.filter(
//         (card) => card.kind === 'inserted' || card.kind === 'replaced',
//       ),
//     );
//   } else if (insertedChecked) {
//     trackButtonClick({ type: 'Filter Data' });
//     setCardData(allCardData.filter((card) => card.kind === 'inserted'));
//   } else if (deletedChecked) {
//     trackButtonClick({ type: 'Filter Data' });
//     setCardData(allCardData.filter((card) => card.kind === 'deleted'));
//   } else if (replacedChecked) {
//     trackButtonClick({ type: 'Filter Data' });
//     setCardData(allCardData.filter((card) => card.kind === 'replaced'));
//   } else {
//     setCardData([...allCardData]);
//   }
// };

export const zoomControl = (documentType, zoomType, setZoomLevel) => {
  if (documentType === originalDocument) {
    if (zoomType === addition) {
      setZoomLevel((prevZoomLevel) => {
        if (prevZoomLevel.ORIGINAL_DOCUMENT > MAX_ZOOM_LEVEL) {
          return prevZoomLevel;
        }
        return {
          ...prevZoomLevel,
          ORIGINAL_DOCUMENT: prevZoomLevel.ORIGINAL_DOCUMENT + 0.11111,
        };
      });
    } else {
      setZoomLevel((prevZoomLevel) => {
        if (prevZoomLevel.ORIGINAL_DOCUMENT < MIN_ZOOM_LEVEL) {
          return prevZoomLevel;
        }
        return {
          ...prevZoomLevel,
          ORIGINAL_DOCUMENT: prevZoomLevel.ORIGINAL_DOCUMENT - 0.11111,
        };
      });
    }
  } else if (documentType === modifiedDocument) {
    if (zoomType === addition) {
      setZoomLevel((prevZoomLevel) => {
        if (prevZoomLevel.MODIFIED_DOCUMENT > MAX_ZOOM_LEVEL) {
          return prevZoomLevel;
        }
        return {
          ...prevZoomLevel,
          MODIFIED_DOCUMENT: prevZoomLevel.MODIFIED_DOCUMENT + 0.11111,
        };
      });
    } else {
      setZoomLevel((prevZoomLevel) => {
        if (prevZoomLevel.MODIFIED_DOCUMENT < MIN_ZOOM_LEVEL) {
          return prevZoomLevel;
        }
        return {
          ...prevZoomLevel,
          MODIFIED_DOCUMENT: prevZoomLevel.MODIFIED_DOCUMENT - 0.11111,
        };
      });
    }
  } else if (documentType === singleDocument) {
    if (zoomType === addition) {
      setZoomLevel((prevZoomLevel) => {
        if (prevZoomLevel.SINGLE_DOCUMENT > MAX_ZOOM_LEVEL) {
          return prevZoomLevel;
        }
        return {
          ...prevZoomLevel,
          SINGLE_DOCUMENT: prevZoomLevel.SINGLE_DOCUMENT + 0.11111,
        };
      });
    } else {
      setZoomLevel((prevZoomLevel) => {
        if (prevZoomLevel.SINGLE_DOCUMENT < MIN_ZOOM_LEVEL) {
          return prevZoomLevel;
        }
        return {
          ...prevZoomLevel,
          SINGLE_DOCUMENT: prevZoomLevel.SINGLE_DOCUMENT - 0.11111,
        };
      });
    }
  }
};

// export function isEmptyObject(obj) {
//   return Object.keys(obj).length === 0;
// }
